// import React from "react";
// import { FaUserCheck, FaHandshake, FaShieldAlt } from "react-icons/fa";
// import limcaLogo from "../../assets/limca_logo2.png"; // Update path if needed

// const Lacks = () => {
//   return (
//     <div className="bg-white py-2 pt-4 px-4 md:px-12">
//       {/* Top Statistics */}

//       {/* Limca Record Section */}
//       <div className="mt-6 bg-yellow-50 rounded-xl p-4 flex flex-col md:flex-row items-center justify-center text-center">
//         <img
//           src={limcaLogo}
//           alt="Where millions found love and began their forever."
//           className="h-16 mb-3 md:mb-0 md:mr-4"
//         />
//         <div>
//           <h4 className="font-extrabold text-[#800000] tracking-wide drop-shadow-md">
//            Happy Marriages! With Royal Rajput Jivansathi
//           </h4>
//           <p className="text-gray-700">
//             The trusted choice of millions for meaningful connections and happy
//             marriages.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Lacks;

// src/components/Lacks.jsx

import React, { useEffect } from "react";
import { FaUserCheck, FaHandshake, FaShieldAlt } from "react-icons/fa";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,600;0,700;1,600&family=Inter:wght@400;500;600&display=swap');

.jblk {
  width: 100%;
  background: linear-gradient(160deg, #1A0505 0%, #3D0A0A 55%, #5A1010 100%);
  font-family: 'Inter', sans-serif;
  padding: clamp(28px, 4vw, 52px) clamp(14px, 5vw, 48px);
  position: relative;
  overflow: hidden;
}

/* gold top/bottom bars */
.jblk::before, .jblk::after {
  content: '';
  position: absolute; left: 0; right: 0; height: 3px;
  background: linear-gradient(90deg, transparent, #C9962A 30%, #E8C46A 50%, #C9962A 70%, transparent);
  z-index: 2;
}
.jblk::before { top: 0; }
.jblk::after  { bottom: 0; }

/* dot-grid */
.jblk-dust {
  position: absolute; inset: 0; pointer-events: none;
  background-image: radial-gradient(circle, rgba(201,150,42,0.10) 1px, transparent 1px);
  background-size: 36px 36px;
}

.jblk-inner {
  position: relative; z-index: 1;
  max-width: 1100px; margin: 0 auto;
  display: flex; flex-direction: column;
  gap: clamp(24px, 3.5vw, 40px);
}

/* ── Stats row ── */
.jblk-stats {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: clamp(10px, 2vw, 18px);
}
.jblk-stat {
  flex: 1 1 clamp(130px, 20%, 200px);
  background: rgba(201,150,42,0.08);
  border: 1px solid rgba(201,150,42,0.22);
  border-radius: 14px;
  padding: clamp(14px,2vw,22px) clamp(12px,1.5vw,18px);
  text-align: center;
  transition: background 0.2s, border-color 0.2s;
}
.jblk-stat:hover {
  background: rgba(201,150,42,0.13);
  border-color: rgba(201,150,42,0.45);
}
.jblk-stat-icon {
  font-size: clamp(22px, 3vw, 28px);
  color: #C9962A;
  margin-bottom: 8px;
}
.jblk-stat-num {
  font-family: 'Playfair Display', serif;
  font-size: clamp(22px, 3.2vw, 34px);
  font-weight: 700;
  color: #E8C46A;
  line-height: 1;
  margin-bottom: 4px;
}
.jblk-stat-lbl {
  font-size: clamp(10.5px, 1.1vw, 12.5px);
  color: rgba(253,246,236,0.68);
  font-weight: 500;
  line-height: 1.4;
}

/* divider */
.jblk-divrow {
  display: flex; align-items: center; justify-content: center; gap: 14px;
}
.jblk-divline { flex: 1; max-width: 120px; height: 1px; background: linear-gradient(90deg,transparent,#C9962A); }
.jblk-divline.r { background: linear-gradient(90deg,#C9962A,transparent); }

/* ── Banner card ── */
.jblk-banner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: clamp(18px, 3vw, 32px);
  background: rgba(201,150,42,0.07);
  border: 1px solid rgba(201,150,42,0.28);
  border-radius: 16px;
  padding: clamp(20px,3vw,32px) clamp(20px,3.5vw,36px);
  flex-wrap: wrap;
}

/* Om emblem — replaces Limca logo */
.jblk-emblem {
  flex-shrink: 0;
  width: clamp(64px, 9vw, 88px);
  height: clamp(64px, 9vw, 88px);
  border-radius: 50%;
  background: rgba(201,150,42,0.12);
  border: 2px solid #C9962A;
  box-shadow: 0 0 0 5px rgba(201,150,42,0.12);
  display: flex; align-items: center; justify-content: center;
  font-size: clamp(28px, 4vw, 40px);
  color: #C9962A;
  font-family: serif;
  filter: drop-shadow(0 0 10px rgba(201,150,42,0.3));
}

.jblk-banner-body { flex: 1; min-width: 200px; }
.jblk-banner-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(17px, 2.2vw, 24px);
  font-weight: 700;
  color: #FDF6EC;
  line-height: 1.3;
  margin-bottom: 6px;
}
.jblk-banner-title em { font-style: italic; color: #E8C46A; }
.jblk-banner-sub {
  font-size: clamp(12px, 1.3vw, 14px);
  color: rgba(253,246,236,0.72);
  line-height: 1.65;
}

/* trust pills */
.jblk-trust-pills {
  display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px;
}
.jblk-tpill {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 12px;
  background: rgba(201,150,42,0.08);
  border: 1px solid rgba(201,150,42,0.25);
  border-radius: 20px;
  font-size: clamp(10px, 1.05vw, 11.5px);
  color: rgba(253,246,236,0.75);
  font-weight: 500; white-space: nowrap;
}
.jblk-tpill-dot { width:5px;height:5px;border-radius:50%;background:#C9962A;flex-shrink:0; }

/* ── Responsive ── */
@media (max-width: 600px) {
  .jblk-banner { flex-direction: column; text-align: center; align-items: center; }
  .jblk-trust-pills { justify-content: center; }
  .jblk-stats { gap: 8px; }
  .jblk-stat { flex: 1 1 calc(50% - 8px); }
}
@media (max-width: 360px) {
  .jblk-stat { flex: 1 1 100%; }
}
`;

/* ── Lotus SVG ── */
const Lotus = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 28 28"
    fill="none"
    aria-hidden="true"
  >
    <ellipse cx="14" cy="16" rx="4" ry="9" fill="#C9962A" opacity=".9" />
    <ellipse
      cx="14"
      cy="16"
      rx="4"
      ry="8"
      fill="#C9962A"
      opacity=".85"
      transform="rotate(-30 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="4"
      ry="8"
      fill="#C9962A"
      opacity=".85"
      transform="rotate(30 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="3.5"
      ry="6"
      fill="#C9962A"
      opacity=".6"
      transform="rotate(-58 14 16)"
    />
    <ellipse
      cx="14"
      cy="16"
      rx="3.5"
      ry="6"
      fill="#C9962A"
      opacity=".6"
      transform="rotate(58 14 16)"
    />
    <ellipse cx="14" cy="24" rx="7" ry="2.5" fill="#C9962A" opacity=".25" />
  </svg>
);

const stats = [
  { Icon: FaUserCheck, num: "5,000+", lbl: "Verified Jain Profiles" },
  { Icon: FaHandshake, num: "2,000+", lbl: "Sacred Unions Formed" },
  { Icon: FaShieldAlt, num: "100%", lbl: "Privacy Protected" },
];

const pills = [
  "Jain Values First",
  "All Sects Welcome",
  "Family Approved",
  "Ahimsa Guided",
];

const Lacks = () => {
  useEffect(() => {
    const id = "jblk-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id;
      el.textContent = CSS;
      document.head.appendChild(el);
    }
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="jblk">
      <div className="jblk-dust" aria-hidden="true" />

      <div className="jblk-inner">
        {/* ── Divider ── */}
        <div className="jblk-divrow" aria-hidden="true">
          <div className="jblk-divline" />
          <Lotus />
          <div className="jblk-divline r" />
        </div>

        {/* ── Banner ── */}
        <div className="jblk-banner">
          {/* Om emblem replaces Limca logo */}
          <div className="jblk-emblem" aria-label="Om — Jain Var Vadhu">
            ꣽ
          </div>

          <div className="jblk-banner-body">
            <h4 className="jblk-banner-title">
              <em>Happy Marriages</em> — with Jain Var Vadhu
            </h4>
            <p className="jblk-banner-sub">
              The trusted choice of thousands of Jain families — uniting souls
              through shared values, Dharma, and the sacred bond of Ahimsa.
            </p>
            <div
              className="jblk-trust-pills"
              role="list"
              aria-label="Platform values"
            >
              {pills.map((p) => (
                <span key={p} className="jblk-tpill" role="listitem">
                  <span className="jblk-tpill-dot" aria-hidden="true" />
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Lacks;
